import { INDENTS } from 'vars/index'

export const ContainerDescriptionDirection = {
  Row: 'row',
  Column: 'column',
} as const
export type ContainerDescriptionDirection =
  (typeof ContainerDescriptionDirection)[keyof typeof ContainerDescriptionDirection]

export const ContainerDescriptionJustifyContent = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly',
} as const
export type ContainerDescriptionJustifyContent =
  (typeof ContainerDescriptionJustifyContent)[keyof typeof ContainerDescriptionJustifyContent]

export const ContainerDescriptionAlignItems = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  Baseline: 'baseline',
} as const
export type ContainerDescriptionAlignItems =
  (typeof ContainerDescriptionAlignItems)[keyof typeof ContainerDescriptionAlignItems]

export const ContainerDescriptionAspectRatio = {
  VERTICAL_DEFAULT: 0.736,
  SQUARE: 1,
  HORIZONTAL_TV_SHOW_OUTER_CARD: 1.265,
  HORIZONTAL_DEFAULT: 1.77,
  HORIZONTAL_TV_SHOW_INNER_CARD: 1.781,
} as const
export type ContainerDescriptionAspectRatio =
  (typeof ContainerDescriptionAspectRatio)[keyof typeof ContainerDescriptionAspectRatio]

export const ContainerDescriptionColumnGap = {
  INDENT_0: INDENTS.INDENT_0,
  INDENT_20: INDENTS.INDENT_20,
  INDENT_40: INDENTS.INDENT_40,
  INDENT_60: INDENTS.INDENT_60,
  INDENT_80: INDENTS.INDENT_80,
} as const
export type ContainerDescriptionColumnGap =
  (typeof ContainerDescriptionColumnGap)[keyof typeof ContainerDescriptionColumnGap]

export const ContainerDescriptionRowGap = {
  INDENT_0: INDENTS.INDENT_0,
  INDENT_20: INDENTS.INDENT_20,
  INDENT_40: INDENTS.INDENT_40,
  INDENT_60: INDENTS.INDENT_60,
  INDENT_80: INDENTS.INDENT_80,
} as const
export type ContainerDescriptionRowGap =
  (typeof ContainerDescriptionRowGap)[keyof typeof ContainerDescriptionRowGap]
